<div class="stroke-selector flex-row" (click)="$event.stopPropagation()">
  <div (click)="toggleSelector()" [matTooltip]="'Stroke ( s )'">
    <div *ngIf="color; else noFill" style="margin: 2px 2px 0">
      <img
        src="./assets/icons/stroke_selector.svg"
        alt=""
        style="width: 16px; position: relative; top: 1px"
      />
    </div>

    <ng-template #noFill>
      <div style="margin: 2px">
        <img
          src="./assets/icons/stroke_selector.svg"
          alt=""
          style="width: 16px; position: relative; top: 2px"
        />
      </div>
    </ng-template>
  </div>
</div>
